import React from 'react';

import {Sequence} from 'biojs/Sequence';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import * as sequtil from 'molbio/SeqUtil';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface LinksRowProps {
  primerFwd: SequencePrimer;
  primerRev: SequencePrimer;
  productLength: number;
  sequence: Sequence;
}

function LinksRow({primerFwd, primerRev, productLength, sequence}: LinksRowProps): JSX.Element {
  return (
    <>
      <tr>
        <td>{primerFwd.name()}</td>
        <td>+ / {sequtil.modelToDisplay(primerFwd.bindPosition(sequence), sequence.startIndex())}</td>
        <td rowSpan={2}>{productLength}</td>
      </tr>
      <tr>
        <td>{primerRev.name()}</td>
        <td>&ndash; / {sequtil.modelToDisplay(primerRev.bindPosition(sequence), sequence.startIndex())}</td>
      </tr>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<LinksRowProps>(LinksRow);
